import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../App.js";

//Import AwesomeIcon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

//Import Css
import './soportEmpresasCompt.css'

//Import Component
import { BarraMenuDown } from '../home/barraMenuDown';
import { PanelMenuSlideDV } from '../developComponent/panelMenuSlideDV';
import { CarSoportEmpCompt } from '../home/cardSoportEmpCompt.js'
import { FooterComponent } from '../footerComponent/footerComponent.js'


//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg'
import photoPortadaSoporte from  '../../assets/soporteEmpreAssets/photo-portada-soporte.svg'
import bkPhotoBlock from '../../assets/soporteEmpreAssets/bk-sect-block1.jpg'
import photoBlockA from '../../assets/soporteEmpreAssets/Photo-block-A.jpg'
import photoBlockB from '../../assets/soporteEmpreAssets/Photo-block-B.jpg'
import photoBlockC from '../../assets/soporteEmpreAssets/Photo-block-C.jpg'


export function SoportEmpresasCompt() {

    const {

    //Panel Menu Slide Dv
      openMenuSlideDv,
      setOpenMenuSlideDv,
      valorScreenDv,
      setValorScreenDv

    } = useContext(AppContext);

    const bkBlockPhoto = { 

        backgroundImage: `url(${bkPhotoBlock})`, 
        backgroundSize: "cover", 
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat" 

    };


    return(


        <div className='container-all-soporte'>

            <div className='box-portada-soporte'>
                <BarraMenuDown />

                <PanelMenuSlideDV
                    activeMenu='soporte-empresas'
                />

                {/* SECCION BOTON Y LOGO   */}
                <div className='box-btn-slide-logo-soporte'>

                    <div className='box-btn-menu-slide-soporte'>

                        <button className="btn-menu-slide-soporte" onClick={() => setOpenMenuSlideDv(!openMenuSlideDv)}>
                            
                            <span id='btn-slide-menu-open-soporte' className="material-symbols-outlined">menu</span>
                            
                        </button>

                    </div>


                    <div className='box-logo-webmedia-soporte'>

                        <img className='logo-webmedia-soporte' src={LogoWebmedia} alt="Logo WebMedia"/>

                    </div>

                </div>

                {/* SECCION PORTADA INFO */}
                <div className='box-text-photo-soporte'>
                    <div className='box-text-soporte'>
                        <h2 className='title-soporte'>SOPORTE EMPRESAS</h2>
                        <p className='text-soporte'>
                            Soporte y asesoramiento en servicios 
                            digitales, instalación de software, 
                            configuración de sistemas operativos
                            y bases de datos.
                        </p>
                    </div>

                    <div className='box-photo-portada-soporte'>
                        <img className='photo-portada-soporte' src={photoPortadaSoporte}/>
                    </div>

                </div>

            </div> 
            {/* // Fin box portada soporte */}

            {/* SECCION BLOCK INFO PORTADA   */}
            <div className='box-sections-blocks-info-soporte'>

                <div className='box-block-bk box-servicios-block-A' style={bkBlockPhoto}>

                        {/* Block Info A */}
                        <div className='content-blocks-soporte content-block-A'>

                            <div className='box-info-photo-section-block'>

                                <div className='box-text-info-block'>
                                    <h2 className='title-info-block'>SOPORTE Y ASESORAMIENTO EN SERVICIOS DIGITALES</h2>
                                    <div className='line-divisor-block'></div>
                                    <p className='text-info-block'>
                                        Asesoramos y brindamos soporte para aplicaciones y servicios 
                                        digitales de uso corporativo como: Microsoft Team, Google Workspace, 
                                        Zoom, Odoo, Slack, HubSpot entre otros.
                                    </p>
                                </div>

                            </div>

                            {/* Block Photo block A */}
                            <div className='box-photo-block box-photo-block-A'>
                                    <img className='photo-block photo-block-A' src={photoBlockA} alt='Soporte y asesoramiento en servicios digitales'/>
                            </div>

                        </div>

                </div>

                

                <div className='box-banner-block-blue'>

                        {/* Block Info C */}
                        <div className='box-content-blocks'>

                            {/* Block Photo block C */}
                            <div className='box-photo-block-c'>
                                    <img className='photo-block-c' src={photoBlockC} alt='Soporte y asesoramiento en servicios digitales'/>
                            </div>

                            <div className='box-info-block-c'>
                                <h2 className='title-info-block-c'>INSTALACIÓN Y CONFIGURACIÓN DE SOFTWARE</h2>
                                <div className='line-divisor-block-c'></div>
                                <p className='text-info-block-c'>
                                    Instalamos software con licencias originales o 
                                    alternas para uso personal o profesional: 
                                    Paquete de Office, Adobe, Sistema de Bodega, 
                                    Sistemas de vigilancia, entre otros. 
                                </p>
                            </div>

                        </div>

                </div>



                <div className='box-block-bk box-servicios-block-B' style={bkBlockPhoto}>

                        {/* Block Info B */}
                        <div className='content-blocks-soporte content-block-A'>

                            <div className='box-info-photo-section-block'>

                                <div className='box-text-info-block'>
                                    <h2 className='title-info-block'>CONFIGURACIÓN DE SISTEMAS Y BASE DE DATOS.</h2>
                                    <div className='line-divisor-block'></div>
                                    <p className='text-info-block'>
                                        Configuración de Windows, Reinicio de Sistema Operativo, 
                                        Back Up de datos, creación y gestión de bases de datos 
                                        para bodegas de productos entre otros.
                                    </p>
                                </div>

                            </div>

                            {/* Block Photo block A */}
                            <div className='box-photo-block box-photo-block-A'>
                                    <img className='photo-block photo-block-A' src={photoBlockB} alt='Soporte y asesoramiento en servicios digitales'/>
                            </div>

                        </div>

                </div>

            </div>


            {/* SECTION CARD SOPORTE EMPRESAS */}
            <div className='container-sect-soporte-empresa'>

                <CarSoportEmpCompt />

            </div>

                <FooterComponent />

        </div>

    );
}